/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SubscriptionSourceTypeEnum } from './subscriptionSourceTypeEnum';
import { ServiceTypeEnum } from './serviceTypeEnum';
import { SubscriptionStatesEnumV4 } from './subscriptionStatesEnumV4';


export interface RawSubscriptionV4PatchSpec { 
    serial_number: string;
    billing_account_id?: string;
    billing_engine_subscription_id?: string;
    charge_id?: string;
    csp_service_type?: ServiceTypeEnum;
    datacenter?: string;
    derived_subscription_status?: SubscriptionStatesEnumV4;
    end_ts?: Date;
    org_id?: string;
    quantity?: number;
    seller?: string;
    sku?: string;
    start_ts?: Date;
    subscription_api_response?: object;
    subscription_id?: string;
    subscription_source_type?: SubscriptionSourceTypeEnum;
    subscription_status?: string;
    subscription_type?: string;
    updated_ts?: Date;
    v3_subscription_id?: string;
    v4_subscription_type?: string;
}
export namespace RawSubscriptionV4PatchSpec {
}


